export const VERDICTS = {
  clear: {
    label: "CLEAR",
    text: "#10B981",
    bg: "rgba(16,185,129,0.12)",
    border: "rgba(16,185,129,0.35)",
  },
  suspicious: {
    label: "SUSPICIOUS",
    text: "#F59E0B",
    bg: "rgba(245,158,11,0.12)",
    border: "rgba(245,158,11,0.35)",
  },
  high_risk: {
    label: "HIGH RISK",
    text: "#EF4444",
    bg: "rgba(239,68,68,0.14)",
    border: "rgba(239,68,68,0.4)",
  },
};

export const SEVERITY = {
  high: { text: "#EF4444", bg: "rgba(239,68,68,0.14)", label: "HIGH" },
  medium: { text: "#F59E0B", bg: "rgba(245,158,11,0.12)", label: "MEDIUM" },
  low: { text: "#38BDF8", bg: "rgba(56,189,248,0.12)", label: "LOW" },
};

export function VerdictBadge({ verdict, testid }) {
  const v = VERDICTS[verdict] || VERDICTS.clear;
  return (
    <span
      data-testid={testid}
      className="font-mono text-[11px] font-semibold px-2.5 py-1 rounded-md tracking-wider"
      style={{ color: v.text, background: v.bg, border: `1px solid ${v.border}` }}
    >
      {v.label}
    </span>
  );
}

export function SeverityBadge({ severity }) {
  const s = SEVERITY[severity] || SEVERITY.low;
  return (
    <span
      className="font-mono text-[10px] font-semibold px-2 py-0.5 rounded tracking-wider"
      style={{ color: s.text, background: s.bg }}
    >
      {s.label}
    </span>
  );
}
